import React, { FC } from 'react'
import Tabs from '@roo/roo/Tabs'
import { TabsProps } from '@roo/roo/es/Tabs/interface'
import { isRtl } from '@/common/utils/i18n'
import styles from './index.module.less'

/**
 * PageTabs — 统一风格的页面级 Tabs 组件
 *
 * 基于 @roo/roo Tabs 封装，覆盖样式以符合设计规范：
 *   - 底部全宽分隔线：2px 实心黑色
 *   - 激活 tab 指示器：2px 粗黑色短线，与 tab 文字等宽
 *   - 激活 tab 字体加粗（500）
 *   - 非激活 tab 字色 #595959
 *   - 去除多余 padding / 默认黄色渐变
 *
 * 用法与 @roo/roo Tabs 完全一致，直接透传所有 props。
 * Pane 仍使用原生 Tabs.Pane。
 */
const PageTabs: FC<TabsProps> & { Pane: typeof Tabs.Pane } = ({ className, ...rest }) => (
  <div className={[styles.pageTabsWrapper, isRtl ? styles.rtlPageTabsWrapper : ''].filter(Boolean).join(' ')}>
    <Tabs
      type="line"
      autoBottomLineWidth
      className={[styles.pageTabs, className].filter(Boolean).join(' ')}
      {...rest}
    />
  </div>
)

PageTabs.Pane = Tabs.Pane

export default PageTabs
